import { LineDrawingManager } from "./lineDrawing";

// /**
//  * Polyline描画を開始
//  * google.maps.drawing.DrawingManager の廃止のため代替実装
//  *
//  * @param map - Google Mapsインスタンス
//  * @param strokeColor - ライン色(#RRGGBB形式)
//  * @returns LineDrawingManager インスタンス
//  */
export const startDrawingManager = (map: google.maps.Map, strokeColor: string) => {
    const drawingManager = new LineDrawingManager({
        drawingMode: "polyline",
        drawingControl: false,
        map: map,
        polylineOptions: {
            strokeColor: strokeColor, // ライン色(#RRGGBB形式)
            strokeOpacity: 1, // ライン透明度 0.0～1.0(デフォルト)
            strokeWeight: 2, // ライン太さ(単位ピクセル)
            editable: true,
        },
    });

    return drawingManager;
}

/**
 * Polyline描画を停止
 *
 * @param drawingManager - LineDrawingManager インスタンス
 */
export const endDrawingManager = (drawingManager: LineDrawingManager) => {
    drawingManager.setDrawingMode(null)
}
